/* eslint-disable react-hooks/exhaustive-deps */
import { Card, Checkbox, Modal, Rate, Tag } from "antd"
import { useDispatch, useSelector } from "react-redux";
import { setModalState, triggerResumeEditor, updateModalParams, updateSavedJob, updateTask } from "../../store/reducers/Modal/actions";
import { FaPencilAlt } from "@react-icons/all-files/fa/FaPencilAlt";
import { MdFileDownload } from "@react-icons/all-files/md/MdFileDownload";
import DocumentThumbnail from "./Components/DocumentThumbnail";
import Button from "../../components/forms/Button";
import { FaLock } from '@react-icons/all-files/fa/FaLock';
import { useEffect, useState } from "react";
import { postRequest } from "../../services/requestService";
import downloadCoverLetterAsPDF from "../CoverLetterModal/service";
import { getLastResume } from "../../services/resumeService";
import { BUTTON_VARIANT_APP_SECONDARY, BUTTON_VARIANT_UPGRADE } from "../../components/forms/Button/constants";
import { refreshStats, updatedSavedJob } from "../../store/reducers/Jobs/actions";
import { hasCredits } from "../../services/billingService";
import { FaMagic } from "@react-icons/all-files/fa/FaMagic";
import { FaEye } from "@react-icons/all-files/fa/FaEye";
import { getUserData } from "../../store/reducers/Auth/actions";
import { reportEvent, trackServerEvent } from "../../services/analyticsService";
import { getCompanyName } from "../../services/jobParser";
import "./index.scss";
import { getTaskStatus } from "../../services/savedJobService";
import { getFriendlyTime } from "../../services/textService";

const ApplicationKitModal = props => {
    const { isApplicationModalOpen, savedJob } = useSelector(({ ModalReducer }) => ModalReducer);
    const { userDetails } = useSelector(({ AuthReducer }) => AuthReducer);
    const [loading, setLoading] = useState();
    const [generateResumeLoading, setGenerateResumeLoading] = useState(false);
    const [showAllRequirements, setShowAllRequirements] = useState(false);
    const hasActiveSubscription = !!userDetails?.subscription?.active;
    const resume = getLastResume(userDetails)
    const job = savedJob?.jobDetails?.createdAt ? savedJob.jobDetails : savedJob?.job;

    const dispatch = useDispatch()

    const onClose = () => {
        dispatch(setModalState('isApplicationModalOpen', false))
    }
    const onUpgradeClick = () => {
        reportEvent('upgrade_btn', 'click', { source: 'applicationKitResume' })
        dispatch(setModalState('isUpgradeModalOpen', true))
    }
    const refreshApplicationKit = async () => {
        setLoading(true)
        // TODO: Call API with SavedJob
        const res = await postRequest(`application/${savedJob._id}`)
        await trackServerEvent('load-application-modal')
        dispatch(updatedSavedJob(res.data.savedJob))
        dispatch(refreshStats())
        reportEvent('auth', 'trigger_application_modal')
        dispatch(setModalState('isApplicationModalOpen', true, { savedJob: res.data.savedJob }))
        // TODO: 
        setLoading(false)
    }
    const onGenerateResumeClick = async () => {
        if (!savedJob.resume) {
            setGenerateResumeLoading(true)
            const res = await postRequest('application/generate-resume', { savedJobId: savedJob._id })
            dispatch(updateModalParams({ savedJob: res.data.savedJob }))
            dispatch(getUserData())
        }
        dispatch(setModalState('isApplicationModalOpen', false))

        dispatch(triggerResumeEditor({ savedJob }))
        setGenerateResumeLoading(false)
    }
    const onDownloadCoverLetter = () => {
        reportEvent('cover_letter', 'export_click', { source: 'applicationModal' })
        trackServerEvent('download-cover-letter')
        downloadCoverLetterAsPDF(userDetails, resume, savedJob?.application?.coverLetterText, job?.jobTitle)
        reportEvent('cover_letter', 'export_success', { source: 'applicationModal' })
        dispatch(updateTask(savedJob, 'generateCover', true))

    }
    const toggleRequirements = () => {
        setShowAllRequirements(!showAllRequirements);
    };

    useEffect(() => {
        if (isApplicationModalOpen && savedJob) {
            reportEvent('application', 'view')
            refreshApplicationKit()
        }
    }, [isApplicationModalOpen]);


    if (!savedJob) return null;
    const shouldShowResumeButton = savedJob.resume || (hasActiveSubscription)

    const { jobDetails } = savedJob;
    const displayedRequirements = showAllRequirements
        ? jobDetails.jobRequirements?.skills
        : (jobDetails.jobRequirements?.skills || []).slice(0, 3);
    const hasMoreRequirements = jobDetails.jobRequirements?.skills?.length > 3;
    const tasks = savedJob.tasks || {}
    const tasksStatus = getTaskStatus(tasks)
    return (
        <Modal className="application-modal"
            onCancel={() => onClose()}
            open={isApplicationModalOpen} footer={null}>
            <div className="title">Here is your Application Kit!</div>
            <div className="subtitle">Everything you need to nail this job application.</div>
            <div className="job-details">

                <div className="company">{getCompanyName(savedJob)}</div>
                <div className="job-title">{jobDetails.jobTitle}</div>
                <Tag style={{ marginTop: 5 }}><div className="posted-at">{`Imported: ${getFriendlyTime(savedJob.createdAt)}`}</div></Tag>
                {!loading && <div className="mini-card tasks">
                    <div className="tasks-title">
                        <div>Tasks</div>
                        {tasksStatus?.left ? <Tag>{`${tasksStatus.left} left`}</Tag> : <Tag className="success">You're all set 🎉</Tag>}
                    </div>
                    <div className="items">
                        {[
                            { title: "Generate Cover Letter", property: "generateCover" },
                            { title: "Generate Resume", property: "generateResume" },
                            { title: "Apply on Website", property: "applyJob" },
                            { title: "Email Recruiter", property: "emailRecruiter" },
                            { title: "Follow-Up with Recruiter", property: "emailFollowup" },
                            { title: "Got Interview", property: "interview" },
                        ]
                            .map(task => <div className={`task-item ${tasks[task.property] ? 'completed' : ''}`}>
                                <div className="inner-row">
                                    <div className="left">
                                        <Checkbox checked={tasks[task.property]} onChange={e => dispatch(updateTask(savedJob, task.property, e.target.checked))} />
                                    </div>
                                    <div className="task-title">{task.title}</div>
                                </div>
                                <div className="line" />
                            </div>)}
                    </div>
                </div>}

                {!loading && <div className="mini-card job-requirements">
                    <div className="title">Job Requirements</div>
                    <div className="items">
                        {displayedRequirements.map((req, idx) => {
                            return (
                                <div key={idx} className="requirement-item">
                                    <div className="skill">{req.skill}</div>
                                    <div className="count">{`${req.count} times`}</div>
                                </div>
                            )
                        })}
                        {hasMoreRequirements && (
                            <div className="show-more-btn" onClick={toggleRequirements}>
                                {showAllRequirements ? 'Show less' : 'Show more'}
                            </div>
                        )}
                    </div>
                </div>}
            </div>
            <Card loading={loading} className="inner-card">
                <div className="inner">

                    <div className="features">
                        {/* COVER LETTER */}
                        <div className="feature">
                            <div className="feature-header">
                                <div className="title">Cover Letter</div>
                                <div className="actions">
                                    <div className="action-btn" onClick={() => {
                                        dispatch(setModalState('isCoverLetterModalOpen', true, { savedJob }))
                                        trackServerEvent('edit-cover-letter')
                                    }}>
                                        <FaPencilAlt />
                                        <div className="text" >
                                            Edit
                                        </div>
                                    </div>

                                    <div className="action-btn">
                                        <MdFileDownload style={{ fontSize: 21 }}
                                            onClick={onDownloadCoverLetter}
                                        />
                                    </div>
                                </div>
                            </div>
                            <DocumentThumbnail active variant="cover" savedJob={savedJob} />
                        </div>

                        {/* RESUME FILE */}
                        <div className="feature resume">
                            <div className="feature-header">
                                <div className="title">Job-Specific Resume</div>
                                {savedJob.resume && <div className="actions">
                                    <div className="action-btn" onClick={() => {
                                        trackServerEvent('edit-resume')
                                        dispatch(triggerResumeEditor(savedJob.resume))
                                    }}>
                                        <FaPencilAlt />
                                        <div className="text">
                                            Edit
                                        </div>
                                    </div>

                                    {/* <div className="action-btn">
                                        <MdFileDownload style={{ fontSize: 21 }} />
                                    </div> */}
                                </div>}
                            </div>
                            <DocumentThumbnail active variant="resume" savedJob={savedJob} hidden={!(shouldShowResumeButton && savedJob?.resume)} />
                            {shouldShowResumeButton && <div className="generate-btn-wrapper">
                                {hasCredits(userDetails) || savedJob.resume ? <Button variant={BUTTON_VARIANT_APP_SECONDARY} className="generate-btn"
                                    onClick={onGenerateResumeClick} loading={generateResumeLoading}
                                >
                                    {savedJob.resume && <>
                                        <FaEye />
                                        View Resume
                                    </>}
                                    {!savedJob.resume && hasActiveSubscription && <>
                                        <FaMagic />
                                        Generate
                                    </>}

                                </Button> : <div className="empty-state" />}
                            </div>}
                            {!hasActiveSubscription && !savedJob.resume && <Button className="upgrade-btn" variant={BUTTON_VARIANT_UPGRADE} onClick={onUpgradeClick}>
                                <FaLock />
                                Upgrade</Button>}
                        </div>
                    </div>
                </div>


            </Card>

            <div className="testimonial">
                <Rate value={5} />
                <div className="text">Get In Genie helped me make a progress in 2 days that I haven't made in six months and I finally got my first job as a data analyst.</div>
                <div className="author">Max W. / Junior Data Analyst</div>
            </div>

        </Modal>
    )
}

export default ApplicationKitModal;